// Require the jQuery library and create a deferred object
// to handle the library loading notifications
import jQuery from 'jquery';
import config from './../modules/Config/Config';

let facebookSDK = jQuery.Deferred();

function makePost(post) {

  var $post = jQuery('<div>'),
      $header = jQuery('<div>'),
      $icon = jQuery('<img>'),
      $user = jQuery('<div>'),
      $date = jQuery('<div>'),
      $message = jQuery('<div>'),
      $container = jQuery('<div>');

  var postDate = new Date();
  postDate.setTime(post.created_time * 1000);

  $post.css({
    width: '100%',
    margin: '12px 0',
    backgroundColor: '#ffffff',
    padding: '12px',
    boxShadow: '0 1px 2px rgba(0, 0, 0, .12)'
  });

  $icon.
    css({
      float: 'left',
      width: '40px',
      height: '40px',
      marginRight: '12px',
      border: '1px solid rgba(0, 0, 0, .1)'
    }).
    attr('src', post.from.picture.data.url);

  $user.
    css({
      height: '20px'
    }).append(
      jQuery('<a>').attr('href', 'https://www.facebook.com/' + post.id.split('_')[1]).html(post.from.name)
    );

  $date.
    css({
      height: '20px',
      fontSize: '75%',
      lineHeight: '20px',
      color: '#aaaaaa'
    }).
    html(
      postDate.toLocaleString()
    );

  $header.
    append(
      jQuery('<a>').attr('href', 'https://www.facebook.com/' + post.id.split('_')[1]).append($icon)
    ).
    append($user).
    append($date);

  $message.css({
    margin: '12px 0',
    fontSize: '80%'
  }).html(post.message);

  $container.css({
    position: 'relative',
    width: '100%',
    paddingBottom: '56.25%',
    backgroundColor: '#000000'
  });

  var $content = post.type === 'video' ? (post.source.match(/fbcdn\.net/) !== null ? jQuery('<video>') : jQuery('<iframe>')) : jQuery('<img>');

  $content.
    css({
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%'
    }).
    attr('poster', post.full_picture).
    attr('controls', true).
    attr('src', post.type === 'video' ? post.source : post.full_picture);

  return $post.
    append($header).
    append($message).
    append($container.append($content));
}

// The Facebook defined callback function
window.fbAsyncInit = function() {

  // Once the SDK is loaded, run the Facebook init code
  FB.init({
    appId      : config.facebook[0].key,
    xfbml      : true,
    version    : 'v2.8'
  });

  // Resolve the Facebook promise with the now initialized Facebook object
  facebookSDK.resolve(FB);

  var $fbContainer = jQuery('#almanac-facebook-container');

  if ($fbContainer.length > 0) {
    var postList = [];

    FB.api(
      '/tptalmanac/feed',
      {
        access_token : 'EAANboQ2QIKgBABTrVkmiYoG0wgoLB0tQmK0XxqKoDw7euVMgZA5zJg1TpRYWaHtAaoOzXbLpG27ixa4Bs65WL9Ef4jpMuNKJzDQ4bFBG0RTppz720VQF9ZBkDxAIVfB1PfMTlASXnyZBUDbodX3Miiqj92TZBoIZD',
        fields: 'from{name, link, picture}, message, object_id, created_time, type, source, full_picture',
        date_format: 'U'
      },
      function (posts) {

        if (posts && !posts.error) {

          posts.data.slice(0, 5).map(function(post) {
            postList.push(
              {
                updated: new Date(post.created_time),
                element: makePost(post)
              }
            );

            postList.sort(function (a, b) {
              return b.updated - a.updated;
            });

            postList.forEach(function(postObj) {
              $fbContainer.append(
                postObj.element
              );
            });
          });
        }
      }
    );
  }
};

// Asynchronously load in the Facebook SDK
(function(d, s, id){
  var js, fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) {return;}
  js = d.createElement(s); js.id = id;
  js.async = 1;
  js.src = "https://connect.facebook.net/en_US/sdk.js";
  fjs && fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));

// Set a time limit of 5 seconds for the Facebook SDK
// to load. After that, consider the loading as failed
setTimeout(function() {
  facebookSDK.reject(
    {
      msg: 'Facebook SDK took too long to load'
    }
  );
}, 5000);

export default facebookSDK